import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { SectionFormFactory } from '../../sections/section-form-factory';

export class SectionUtils {

  static sortSectionsForUI(sectionFormArray: UntypedFormArray): void {
    const sectionTypeValues = Object.values(SectionType);

    sectionFormArray.controls.sort((a: AbstractControl, b: AbstractControl) => {
      const aIndex = sectionTypeValues.findIndex((stv) => stv === this.sectionType(a));
      const bIndex = sectionTypeValues.findIndex((stv) => stv === this.sectionType(b));
      if (aIndex === bIndex) {
        return this.sectionOrder(a) - this.sectionOrder(b);
      }
      return aIndex - bIndex;
    });
  }

  static sectionType(abstractControl: AbstractControl): string {
    const formGroup = abstractControl as UntypedFormGroup;
    return formGroup.get('type')?.value;
  }

  static addSection(sectionFormArray: UntypedFormArray, sectionType: SectionType): void {
    const sectionFormGroup = SectionFormFactory.build(sectionType);
    sectionFormGroup.get('order').setValue(this.getNextSectionOrderNumber(sectionFormArray));
    sectionFormArray.push(sectionFormGroup);
  }

  private static sectionOrder(sectionControl: AbstractControl): number {
    const formGroup = sectionControl as UntypedFormGroup;
    return formGroup.get('order')?.value;
  }

  private static getNextSectionOrderNumber(sectionFormArray: UntypedFormArray): number {
    let next = -1;
    sectionFormArray.controls.forEach((fg: UntypedFormGroup) => {
      const order = fg.get('order').value;
      next = order > next ? order : next;
    });
    return next + 1;
  }
}
